module.exports = __webpack_public_path__ + "media/images/index-desc-wizard-5e1d2a8931b27c3945608fd48a882ccf.svg";